import styled from 'styled-components';
import Chip from '@mui/material/Chip';

export const GeneChipWrapper = styled(Chip)`
    margin: 6px 6px 0 0;
`;
